import React from 'react';
import './BusinessDrivers.scss';

function BusinessDrivers() {
    return <>Let's Drive Some Bizness!</>;
}

export default BusinessDrivers;
